/* Rendu avis produit Petzeal FR -- badge + bandeau (reviews_strip existant) + grille.
   Structure PLATE des le depart (pas de cle de locale en JS). Zero app tierce. */
(function () {
  "use strict";

  var PTZRV_LABELS = {
    "fr": { "heading": "Avis de nos clients", "word": "avis" },
    "en": { "heading": "Reviews from our customers", "word": "reviews" },
    "de": { "heading": "Bewertungen unserer Kunden", "word": "Bewertungen" },
    "es": { "heading": "Opiniones de nuestros clientes", "word": "opiniones" },
    "it": { "heading": "Recensioni dei nostri clienti", "word": "recensioni" },
    "nl": { "heading": "Beoordelingen van onze klanten", "word": "beoordelingen" },
    "pt-PT": { "heading": "Comentários de nossos clientes", "word": "comentários" },
    "da": { "heading": "Anmeldelser fra vores kunder", "word": "anmeldelser" },
    "no": { "heading": "Anmeldelser fra våre kunder", "word": "anmeldelser" },
    "sv": { "heading": "Recensioner från våra kunder", "word": "recensioner" },
    "fi": { "heading": "Asiakkaidemme arvostelut", "word": "arvostelua" },
    "tr": { "heading": "Müşterilerimizden gelen yorumlar", "word": "yorum" },
    "et": { "heading": "Arvustused meie klientidelt", "word": "arvustust" },
    "ro": { "heading": "Recenzii de la clienții noștri", "word": "recenzii" },
    "sk": { "heading": "Recenzie od našich zákazníkov", "word": "recenzií" },
    "el": { "heading": "Κριτικές από τους πελάτες μας", "word": "κριτικές" },
    "ar": { "heading": "آراء من عملائنا", "word": "تعليقات" },
    "is": { "heading": "Umsagnir frá viðskiptavinum okkar", "word": "umsagnir" }
  };

  function getLabels() {
    var loc = document.body.getAttribute("data-ptzfr-locale") || "fr";
    return PTZRV_LABELS[loc] || PTZRV_LABELS.fr;
  }

  function starsHtml(rating, size) {
    size = size || 14;
    var full = '<svg viewBox="0 0 18 19" width="' + size + '" height="' + size + '" fill="#3A6351" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.4 0.565613C2.41766 0.565613 0 2.98328 0 5.96561V13.1656C0 16.1479 2.41766 18.5656 5.4 18.5656H12.6C15.5823 18.5656 18 16.1479 18 13.1656V5.96561C18 2.98328 15.5823 0.565613 12.6 0.565613H5.4ZM10.3718 7.67804L9.00041 3.73275L7.62903 7.67804L3.45306 7.76314L6.78147 10.2866L5.57196 14.2844L9.00041 11.8987L12.4289 14.2844L11.2194 10.2866L14.5478 7.76314L10.3718 7.67804Z"/></svg>';
    var empty = full.replace('fill="#3A6351"', 'fill="#D8D8D8"');
    var out = "";
    for (var i = 0; i < 5; i++) out += i < rating ? full : empty;
    return out;
  }

  function getReviews(productId) {
    var data = window.PZFR_REVIEWS || {};
    return data[String(productId)] || null;
  }

  function renderStrip(container, reviews) {
    var track = container.querySelector(".ptz-bs-track");
    if (!track) return;
    var cards = reviews.concat(reviews).map(function (r) {
      return (
        '<div class="ptz-bs-card">' +
          '<div class="ptz-bs-row1">' +
            '<span class="ptz-bs-author">' + r.author + "</span>" +
            '<div class="ptz-bs-stars">' + starsHtml(r.rating) + "</div>" +
          "</div>" +
          '<div class="ptz-bs-text">' + r.reviewBody + "</div>" +
        "</div>"
      );
    });
    track.innerHTML = cards.join("");
  }

  function renderGrid(container, reviews) {
    var grid = container.querySelector("[data-ptzrv-grid]");
    if (!grid) return;
    var labels = getLabels();
    var heading = container.querySelector(".ptzrv-grid-heading");
    if (heading) heading.textContent = labels.heading;
    var avg = (reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length).toFixed(1);
    var badge = container.querySelector("[data-ptzrv-grid-badge]");
    if (badge) {
      badge.innerHTML =
        '<span class="ptzrv-grid-badge-stars">' + starsHtml(Math.round(avg)) + "</span>" +
        '<span class="ptzrv-grid-badge-text">' + avg + " / 5 &middot; " + reviews.length + " " + labels.word + "</span>";
    }
    grid.innerHTML = reviews.map(function (r) {
      return (
        '<div class="ptzrv-grid-card">' +
          '<div class="ptzrv-grid-card-top">' +
            '<span class="ptzrv-grid-author">' + r.author + "</span>" +
            '<div class="ptzrv-grid-stars">' + starsHtml(r.rating) + "</div>" +
          "</div>" +
          '<p class="ptzrv-grid-text">' + r.reviewBody + "</p>" +
        "</div>"
      );
    }).join("");
    container.style.display = "";
  }

  function renderBadge(container, reviews) {
    var avg = (reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length).toFixed(1);
    var starsC = container.querySelector("[data-ptzrv-badge-stars]");
    var textC = container.querySelector("[data-ptzrv-badge-text]");
    if (starsC) starsC.innerHTML = starsHtml(Math.round(avg), 15);
    if (textC) textC.textContent = avg + " (" + reviews.length + ")";
    var infoContainer = container.closest(".product__info-container") || document;
    var priceEl = infoContainer.querySelector(".price");
    if (priceEl) {
      container.style.display = "inline-flex";
      container.style.verticalAlign = "middle";
      container.style.marginLeft = "6px";
      container.style.gap = "4px";
      priceEl.style.display = "flex";
      priceEl.style.flexWrap = "wrap";
      priceEl.style.alignItems = "center";
      priceEl.style.gap = "8px";
      priceEl.appendChild(container);
    } else {
      container.style.display = "flex";
    }
  }

  function init() {
    var productId = document.body.getAttribute("data-ptzfr-product-id");
    if (!productId) return;
    var reviews = getReviews(productId);

    var badge = document.querySelector("[data-ptzrv-badge]");
    if (badge && reviews && reviews.length > 0) renderBadge(badge, reviews);

    var strip = document.querySelector("[data-ptzrv-strip]");
    if (strip && reviews) renderStrip(strip, reviews);

    var gridSection = document.querySelector("[data-ptzrv-grid-section]");
    if (gridSection) {
      if (reviews && reviews.length > 0) {
        renderGrid(gridSection, reviews);
      } else {
        gridSection.style.display = "none";
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
